import React from "react";
import "bootstrap-icons/font/bootstrap-icons.css";

export type FunnelView = "wave" | "bar";

interface ViewSwitchProps {
  value: FunnelView;
  onChange: (view: FunnelView) => void;
}

// Icon-only buttons; the label is kept for the tooltip and screen readers.
const OPTIONS: Array<{ value: FunnelView; label: string; icon: string }> = [
  { value: "wave", label: "Wave view", icon: "bi-graph-up" },
  { value: "bar", label: "Grid view", icon: "bi-grid-3x3-gap-fill" },
];

// Wave | Bar toggle shown at the top right of each Funnel Monitoring section.
export const ViewSwitch: React.FC<ViewSwitchProps> = ({ value, onChange }) => (
  <div
    className="funnel-minimal-view-switch"
    role="group"
    aria-label="Chart view"
  >
    {OPTIONS.map((option) => (
      <button
        key={option.value}
        type="button"
        className={
          option.value === value
            ? "funnel-minimal-view-switch-option is-active"
            : "funnel-minimal-view-switch-option"
        }
        aria-pressed={option.value === value}
        aria-label={option.label}
        title={option.label}
        onClick={() => onChange(option.value)}
      >
        <i className={`bi ${option.icon}`} aria-hidden="true"></i>
      </button>
    ))}
  </div>
);
